import React from 'react'
import { withStyles } from 'material-ui/styles'
import styles from '../styles'

const DevicesList = () => {
  return (
    <b>devices</b>
  )
}

export default withStyles(styles)(DevicesList)
